export const ISOMETRIC_DEFAULTS = Object.freeze({ heightScale: 1, showVegetation: true, showActivity: true })

export function isometricSettings (sceneSettings) {
  const value = sceneSettings?.isometric || {}, number = Number(value.heightScale)
  return { heightScale: Number.isFinite(number) && number >= .25 && number <= 2.5 ? number : 1,
    showVegetation: value.showVegetation !== false, showActivity: value.showActivity !== false }
}

export function isometricSettingsError (sceneSettings) {
  const value = sceneSettings?.isometric
  if (value == null) return ''
  if (typeof value !== 'object' || Array.isArray(value)) return '2.5D外观设置须为对象'
  if ('heightScale' in value && (value.heightScale === '' || value.heightScale == null || !Number.isFinite(Number(value.heightScale)) || Number(value.heightScale) < .25 || Number(value.heightScale) > 2.5)) return '2.5D建筑高度倍率须为0.25～2.5的有效数值'
  if (['showVegetation', 'showActivity'].some(key => key in value && typeof value[key] !== 'boolean')) return '2.5D显示开关须为布尔值'
  return ''
}
